var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper background-adults"},[_c('div',{staticClass:"error404"},[_c('h1',[_vm._v("Errore 404")]),_c('h2',[_vm._v("Indirizzo non trovato :(")])])])
}]

export { render, staticRenderFns }